// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2YgpX","col":"styles_col__1SrmZ","fulfillmentStatus":"styles_fulfillmentStatus__3-XR0","emailCol":"styles_emailCol__35JTc"};